import { useMap } from "react-leaflet";
import { useEffect } from "react";
import L from "leaflet";

interface AuthTileLayerProps extends L.TileLayerOptions {
  url: string;
  token: string;
}

export function AuthTileLayer({ url, token, ...options }: AuthTileLayerProps) {
  const map = useMap();

  const TileLayerWithHeader = L.TileLayer.extend({
    createTile: function (coords: L.Coords) {
      const tile = document.createElement("img");
      tile.alt = "";
      tile.setAttribute("crossOrigin", "anonymous");

      const tileUrl = this.getTileUrl(coords);

      fetch(tileUrl, {
        headers: {
          Authorization: "Bearer " + (this.options as any).token,
        },
      })
        .then((r) => r.blob())
        .then((blob) => {
          tile.src = URL.createObjectURL(blob);
        });

      return tile;
    },
  });

  useEffect(() => {
    const layer = new (TileLayerWithHeader as any)(url, { token, ...options });
    layer.addTo(map);
    return () => {
      map.removeLayer(layer);
    };
  }, [map, url, token, options]);

  return null;
}